import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaBirthdayCake, FaHeart, FaBriefcase, FaGift } from 'react-icons/fa';
import Card from '../common/Card';

const FeaturedServices = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: FaHeart,
      title: t('services.weddings.title'),
      description: t('services.weddings.description'),
    },
    {
      icon: FaBirthdayCake,
      title: t('services.birthdays.title'),
      description: t('services.birthdays.description'),
    },
    {
      icon: FaBriefcase,
      title: t('services.corporate.title'),
      description: t('services.corporate.description'),
    },
    {
      icon: FaGift,
      title: t('services.anniversaries.title'),
      description: t('services.anniversaries.description'),
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-display font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card key={index} hover className="text-center">
                <div className="flex justify-center mb-4">
                  <div className="p-4 bg-primary-100 rounded-full">
                    <Icon className="text-primary-600 text-4xl" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600">{service.description}</p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturedServices;
